module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNi4yIDE2Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzM1MzUzMzt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmljX2Nsb3NlPC90aXRsZT48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxwb2x5Z29uIGNsYXNzPSJjbHMtMSIgcG9pbnRzPSIxNC44NiAxNiA4LjEgOS4zNCAxLjM1IDE2IDAgMTQuNjcgNi43NSA4IDAgMS4zMyAxLjM1IDAgOC4xIDYuNjcgMTQuODYgMCAxNi4yIDEuMzMgOS40NSA4IDE2LjIgMTQuNjcgMTQuODYgMTYiLz48L2c+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_close.svg
// module id = j5SN
// module chunks = 1